import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {LicensedAgent} from "../../../../shared/interface/licensed-agent";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {ActivatedRoute} from "@angular/router";
import {LicensedAgentService} from "../../../../shared/services/licensed-agent.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {EmployeeService} from "../../../../shared/services/employee.service";
import {Employee, LeaveApplication} from "../../../../shared/interface/employee";
import {UserService} from "../../../../shared/services/user.service";
import {User} from "../../../../shared/interface/user";
import {MatTabChangeEvent} from "@angular/material/tabs";
import {ListResponse} from "../../../../shared/interface/response/list-response";
import {Document} from "../../../../shared/interface/document";
import {FormBuilder, FormControl} from "@angular/forms";

@Component({
  selector: 'app-employee-details',
  templateUrl: './employee-details.component.html',
  styleUrls: ['./employee-details.component.scss']
})
export class EmployeeDetailsComponent implements OnInit, OnDestroy {

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  employeeId: string;
  employeeObject?: Employee;
  userObject?: User;
  employee: ReplaySubject<Employee> = new ReplaySubject<Employee>(1);
  user: ReplaySubject<User> = new ReplaySubject<User>(1);
  userPermissions: ReplaySubject<UserPermissions>;
  modify = false;
  leaveApplication: ReplaySubject<LeaveApplication[]> = new ReplaySubject<LeaveApplication[]>(1);
  selectedTab: number;
  leaveApplicationViewControl: FormControl;
  years: number[] = [];
  initialFilters: any;



  constructor(
    private route: ActivatedRoute,
    private employeeService: EmployeeService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
    private userService: UserService,
    private fb: FormBuilder,

  ) {
    const currentYear = new Date().getFullYear();
    for (let i = currentYear - 5; i <= currentYear ; i++) {
      this.years.push(i);
    }
    this.userPermissions = auth.getUserPermissions();
    this.leaveApplicationViewControl = fb.control(currentYear);
  }

  ngOnInit(): void {
    this.selectedTab = 0;
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.employeeId = params.id;
        this.loadEmployee();
      });
    this.leaveApplicationViewControl.valueChanges.subscribe(() => this.loadLeaveApplication());
  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadEmployee(): void {
    this.employeeService.get(this.employeeId).subscribe((employee: Employee) => {
      this.employee.next(employee);
      this.employeeObject = employee;
      this.loadUser();
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych', error.status.toString(), {
        duration: 2000
      });
    });
  }
  loadUser(): void {
    this.userService.get( this.employeeObject.user.uuid).subscribe((user: User) => {
      this.user.next(user);
      this.userObject = user;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych', error.status.toString(), {
        duration: 2000
      });
    });
  }

  onTabChange(e: MatTabChangeEvent): void {
    if (e.index === 1) {
      this.loadLeaveApplication();
    }
  }
  buildFilters(): any {
    const filters = {...this.initialFilters};

    if (this.leaveApplicationViewControl.value) {
      filters.year = this.leaveApplicationViewControl.value;
    }


    return filters;
  }
  loadLeaveApplication(): void {
    this.employeeService.getLeaveApplication(this.employeeId, this.buildFilters())
      .subscribe((leaveApplication: ListResponse<LeaveApplication>) => {
        this.leaveApplication.next(leaveApplication.items);
      });
  }

  protected readonly takeUntil = takeUntil;
}
